import React from 'react';
import FifthQ from './FifthQ';
import FirstQ from './FirstQ';
import FourthQ from './FourthQ';
import SecondQ from './SecondQ';
import ThirdQ from './ThirdQ';


const Blog = () => {
    return (
        <>
        <FirstQ/>
        <SecondQ/>
        <ThirdQ/>
        <FourthQ/>
        <FifthQ/>
        </>
    );
};

export default Blog;